import { GOALS_OVERVIEW_PAGE_METRIC_CARDS } from 'Deer/metricCards/constants';

export const transformedCardsForOneOnOne = (data) => [
  {
    title: 'Team members with no 1:1s scheduled',
    subTitle: '',
    value: data?.EMP_COUNT_NO_OOO_SCHEDULED?.data,
    color: '',
  },
  {
    title: 'Team members with no 1:1s in last 30 days',
    subTitle: '',
    value: data?.EMP_COUNT_NO_OOO_COMPLETED?.data,
    color: '',
  },
  {
    title: 'Average completion',
    subTitle: '',
    value: `${parseFloat(data?.ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI > 50 ? 'success' : 'warning',
  },
];

export const transformedCardsForCompetencies = (data) => [
  {
    title: 'Team members with no progress',
    subTitle: '',
    value: data?.EMP_COUNT_COMPETENCIES_NO_PROGRESS?.data,
    color: '',
  },
  {
    title: 'Team members with no feedback',
    subTitle: '',
    value: data?.EMP_COUNT_NO_FEEDBACK_RECEIVED?.data,
    color: '',
  },
  {
    title: 'Average proficiency',
    subTitle: '',
    value: `${parseFloat(data?.COMPETENCY_PROGRESS_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.COMPETENCY_PROGRESS_AVERAGE_KPI?.data > 50 ? 'success' : 'warning',
  },
];

export const transformedCardsForGoals = (data, source = '') => [
  {
    cardId: !source ? null : GOALS_OVERVIEW_PAGE_METRIC_CARDS?.[source].teamMemberNoCheckIn,
    title: 'Team members with no check-ins',
    subTitle: '',
    value: data?.EMP_COUNT_NO_GOAL_CHECKINS?.data,
    color: '',
  },
  {
    cardId: !source ? null : GOALS_OVERVIEW_PAGE_METRIC_CARDS?.[source].teamMemberNoGoals,

    title: 'Team members without any goals',
    subTitle: '',
    value: data?.EMP_COUNT_NO_GOALS_SET?.data,
    color: '',
  },
  {
    title: 'Average progress',
    subTitle: '',
    value: `${parseFloat(data?.ACTIVE_GOAL_PROGRESS_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.ACTIVE_GOAL_PROGRESS_AVERAGE_KPI?.data > 50 ? 'success' : 'warning',
  },
];

export const transformedCompanyCardsForCompetencies = (data) => [
  {
    title: 'Team members with no progress in the last 30 days',
    subTitle: '',
    value: data?.EMP_COUNT_COMPETENCIES_NO_PROGRESS?.data,
    color: '',
  },
  {
    title: 'Team members with no feedback received',
    subTitle: '',
    value: data?.EMP_COUNT_NO_FEEDBACK_RECEIVED?.data,
    color: '',
  },
  {
    title: 'Team members with no shared feedback',
    subTitle: '',
    value: data?.EMP_COUNT_NO_FEEDBACK_SHARED?.data,
    count: '',
    color: data?.COMPETENCY_PROGRESS_AVERAGE_KPI?.data > 50 ? 'success' : 'warning',
  },
  {
    title: 'Average competency progress',
    subTitle: '',
    value: `${parseFloat(data?.COMPETENCY_PROGRESS_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.COMPETENCY_PROGRESS_AVERAGE_KPI?.data > 50 ? 'success' : 'warning',
  },
];

export const transformedCompanyCardsForGoals = (data) => [
  {
    cardId: GOALS_OVERVIEW_PAGE_METRIC_CARDS?.company.teamMemberNoCheckIn,
    title: 'Team members with no check-ins',
    subTitle: '',
    value: data?.EMP_COUNT_NO_GOAL_CHECKINS?.data,
    color: '',
  },
  {
    cardId: GOALS_OVERVIEW_PAGE_METRIC_CARDS?.company.teamMemberNoGoals,
    title: 'Team members without any goals',
    subTitle: '',
    value: data?.EMP_COUNT_NO_GOALS_SET?.data,
    color: '',
  },
  {
    cardId: GOALS_OVERVIEW_PAGE_METRIC_CARDS?.company.teamMemberMoreThan5Goals,
    title: 'Team members with >5 goals',
    subTitle: '',
    value: data?.EMP_COUNT_5_GOALS_OR_MORE?.data,
    color: '',
  },
  {
    title: 'Average progress',
    subTitle: '',
    value: `${parseFloat(data?.ACTIVE_GOAL_PROGRESS_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.ACTIVE_GOAL_PROGRESS_AVERAGE_KPI?.data > 50 ? 'success' : 'warning',
  },
];

export const transformedCompanyCardsForOneOnOne = (data) => [
  {
    title: 'Team members without any manager 1:1’s',
    subTitle: '',
    value: 12,
    color: '',
  },
  {
    title: 'Managers without any direct report 1:1’s',
    subTitle: '',
    value: data?.MANAGER_COUNT_NO_OOOS_WITH_REPORTS?.data,
    color: '',
  },
  {
    title: 'Average completion % for my company’s manager 1:1’s',
    subTitle: '',
    value: `${parseFloat(data?.ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI?.averageProgress)}%`,
    count: '',
    color: data?.ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI > 50 ? 'success' : 'warning',
  },
  {
    title: 'Average satisfaction score for my manager 1:1’s',
    subTitle: '',
    value: `${parseFloat(data?.ONE_ON_ONE_SATISFACTION_SCORE_AVERAGE_KPI?.averageProgress) / 5}%`,
    count: '',
    color: data?.ONE_ON_ONE_COMPLETION_PERCENTAGE_AVERAGE_KPI > 50 ? 'success' : 'warning',
  },
];
